import {
  INFORMATION_LIST_FETCH,
  INFORMATION_LIST_SUCCESS,
  INFORMATION_LIST_FAILURE
} from './actionTypes';

import { ADD_INFORMATION_TO_THE_LIST } from '../InformationForm/actionTypes';

const initialState = {
  isLoaded: false,
  informations: [],
  error: []
};

export const informationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case INFORMATION_LIST_FETCH:
      return { ...state, isLoaded: false };
    case INFORMATION_LIST_SUCCESS:
      return { ...state, isLoaded: true, informations: action.payload };
    case ADD_INFORMATION_TO_THE_LIST:
      return {
        ...state,
        isLoaded: true,
        informations: [...state.informations, action.payload]
      };
    case INFORMATION_LIST_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
};

export const isLoaded = state => state.informationList.isLoaded;
export const getInformations = state => state.informationList.informations;
export const getError = state => state.informationList.error;



// WEBPACK FOOTER //
// ./src/modules/InformationList/reducer.js